import React, { useState } from 'react';

import {
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Paper,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { PermissionsGate } from '@components';
import { ButtonV2 } from 'components/common/ui';
import { generateShortId } from '@utils';

const MoreButton = ({ moreOptions, size = 'small', disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (item) => {
    item.onClick();

    handleMenuClose();
  };

  const options = moreOptions?.filter((item) => !item?.hidden);

  return (
    <>
      {options?.length > 0 && (
        <ButtonV2 size={size} onClick={handleOpenMenu} disabled={disabled}>
          <MoreHorizIcon data-testid="MoreHorizIcon" />
        </ButtonV2>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          padding: 0,
        }}
      >
        <Paper
          sx={{
            maxWidth: '300px',
            padding: 0,
            width: '100%',
          }}
        >
          <MenuList
            sx={{
              padding: 0,
              width: '100%',
              minWidth: '100px',
            }}
          >
            {moreOptions?.map((item, index) => {
              return (
                <PermissionsGate
                  key={`more-options-${generateShortId()}`}
                  disabled
                  scopes={item?.entity || []}
                >
                  {!item?.hidden && (
                    <MenuItem
                      disabled={item?.disabled}
                      onClick={() => handleClick(item)}
                      sx={{
                        padding: '12px',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '20px',
                        width: '100%',
                        borderBottom: (theme) =>
                          index !== (moreOptions?.length || 0) - 1 &&
                          `1px solid ${theme.palette.separator}`,
                      }}
                    >
                      <ListItemText>{item?.title}</ListItemText>

                      <ListItemIcon>{item?.icon}</ListItemIcon>
                    </MenuItem>
                  )}
                </PermissionsGate>
              );
            })}
          </MenuList>
        </Paper>
      </Menu>
    </>
  );
};

const memoizedMoreButton = React.memo(MoreButton);
export { memoizedMoreButton as MoreButton };

export default memoizedMoreButton;
